"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustmentTableComponent = void 0;
const core_1 = require("@angular/core");
const account_1 = require("./account");
const permission_service_1 = require("./permission.service");
let AdjustmentTableComponent = class AdjustmentTableComponent {
    constructor(_permission) {
        this._permission = _permission;
        this.account = new account_1.Account();
        this.accountHourlyPulled = {};
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.resolve();
        });
    }
    resolve() {
        return __awaiter(this, void 0, void 0, function* () {
            this.columnHeaderMap = this._permission.getHelmColumns();
            this.columnHeaderKeys = Object.keys(this.columnHeaderMap);
            this.colHeaders = this.columnHeaderKeys.map(columnHeaderKey => {
                return this.columnHeaderMap[columnHeaderKey].header;
            });
        });
    }
};
exports.AdjustmentTableComponent = AdjustmentTableComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdjustmentTableComponent.prototype, "searchTermObject", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdjustmentTableComponent.prototype, "accounts", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdjustmentTableComponent.prototype, "granularityDSP", void 0);
exports.AdjustmentTableComponent = AdjustmentTableComponent = __decorate([
    (0, core_1.Component)({
        selector: 'adjustment-table',
        templateUrl: 'app/adjustment-table.component.html',
        styleUrls: ['styles/adjustment.component.css']
    }),
    __metadata("design:paramtypes", [permission_service_1.PermissionService])
], AdjustmentTableComponent);
//# sourceMappingURL=adjustment-table.component.js.map